import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
  try {
    const persistedState = localStorage.getItem("txtconnect_ng_user");
    const token = localStorage.getItem("txtconnect_ng_user_token");
    return persistedState
      ? {
          ...JSON.parse(persistedState),
          token: token,
        }
      : {
          txtconnect_ng_user: null,
          isVerified: false,
          token: null,
        };
  } catch (error) {
    return {
      txtconnect_ng_user: null,
      isVerified: false,
      token: null,
    };
  }
};

export const userSlice = createSlice({
  name: "txtconnect_ng_user",
  initialState: loadInitialState(),
  reducers: {
    setUser: (state, action) => {
      const { userData, token } = action.payload;
      const isVerified = !!(
        userData?.email_verified_at || userData?.phone_number_verified_at
      );

      state.txtconnect_ng_user = userData;
      state.isVerified = isVerified;
      state.token = token;

      localStorage.setItem(
        "txtconnect_ng_user",
        JSON.stringify({
          txtconnect_ng_user: userData,
          isVerified,
        })
      );

      if (token) {
        localStorage.setItem("txtconnect_ng_user_token", token);
      }
    },
    updateSubscriptionData: (state, action) => {
      if (!state.txtconnect_ng_user) return;
      const { subscriptionData, plan_name, units } = action.payload;
      if (subscriptionData != null) {
        state.txtconnect_ng_user.subscription_plan = subscriptionData;
      }
      if (plan_name != null) {
        state.txtconnect_ng_user.plan_name = plan_name;
      }
      if (typeof units === "number" || (typeof units === "string" && units !== "")) {
        state.txtconnect_ng_user.units = typeof units === "string" ? parseInt(units, 10) : units;
      }
      localStorage.setItem(
        "txtconnect_ng_user",
        JSON.stringify({
          txtconnect_ng_user: state.txtconnect_ng_user,
          isVerified: state.isVerified,
        })
      );
    },

    updateUserUnits: (state, action) => {
      const { units } = action.payload;
      if (state.txtconnect_ng_user) {
        state.txtconnect_ng_user.units = units;
        localStorage.setItem(
          "txtconnect_ng_user",
          JSON.stringify({
            txtconnect_ng_user: state.txtconnect_ng_user,
            isVerified: state.isVerified,
          })
        );
      }
    },

    registerUser: (state, action) => {
      const { userData, token } = action.payload;
      const isVerified = !!(
        userData?.email_verified_at || userData?.phone_number_verified_at
      );

      state.txtconnect_ng_user = userData;
      state.isVerified = isVerified;
      state.token = token;

      localStorage.setItem(
        "txtconnect_ng_user",
        JSON.stringify({
          txtconnect_ng_user: userData,
          isVerified,
        })
      );

      if (token) {
        localStorage.setItem("txtconnect_ng_user_token", token);
      }
    },
    clearUser: (state) => {
      state.txtconnect_ng_user = null;
      state.isVerified = false;
      state.token = null;
      localStorage.removeItem("txtconnect_ng_user");
      localStorage.removeItem("txtconnect_ng_user_token");
    },
  },
});

export const {
  setUser,
  registerUser,
  clearUser,
  updateSubscriptionData,
  updateUserUnits,
} = userSlice.actions;
export default userSlice.reducer;
